import gql from 'graphql-tag'

export const coreCauseDelete = gql`
  mutation coreCauseDelete($coreCauseId: ID!) {
    coreCauseDelete(input: { coreCauseId: $coreCauseId }) {
      success
    }
  }
`
